export function getCurrentTime(): string {
  const date = new Date(Date.now())
  const hours = date.getHours()
  const minutes = date.getMinutes()
  return `${hours > 12 ? hours % 12 : hours}:${minutes < 10 ? `0${minutes}` : minutes} ${
    hours < 12 ? 'AM' : 'PM'
  }`
}
